(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["letufting-faq-sommaire"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.lt-faqs[data-preview-count]').forEach(function (section) {
      var previewCount = parseInt(section.dataset.previewCount, 10) || 4;
      var themes = Array.from(section.querySelectorAll('.lt-faq-theme'));
      if (!themes.length) return;

      var nav  = section.querySelector('.lt-faqs-toc');
      var list = section.querySelector('.lt-faqs-toc__list');

      themes.forEach(function (theme) {
        var titleEl = theme.querySelector('.lt-faq-theme__title');
        var items   = Array.from(theme.querySelectorAll('.lt-faq-item'));

        if (titleEl && list) {
          var li = document.createElement('li');
          li.className = 'lt-faqs-toc__item';

          var a = document.createElement('a');
          a.className   = 'lt-faqs-toc__link';
          a.href        = '#' + theme.id;
          a.textContent = titleEl.textContent.trim();

          var cnt = document.createElement('span');
          cnt.className = 'lt-faqs-toc__count';
          cnt.setAttribute('aria-hidden', 'true');
          cnt.textContent = items.length;

          li.appendChild(a);
          li.appendChild(cnt);
          list.appendChild(li);
        }

        if (items.length > previewCount) {
          var hiddenCount = items.length - previewCount;
          items.slice(previewCount).forEach(function (item) { item.hidden = true; });
          var btn = theme.querySelector('.lt-faq-more');
          if (btn) {
            btn.querySelector('.lt-faq-more__count').textContent = hiddenCount;
            btn.hidden = false;
            var expanded = false;
            btn.addEventListener('click', function () {
              expanded = !expanded;
              if (expanded) {
                items.forEach(function (item) { item.hidden = false; });
                btn.textContent = 'Afficher moins';
              } else {
                items.slice(previewCount).forEach(function (item) { item.hidden = true; });
                btn.innerHTML = '+ <span class="lt-faq-more__count">' + hiddenCount + '</span> autres questions';
              }
            });
          }
        }
      });

      if (nav && list.children.length) nav.hidden = false;

      var tocLinks = Array.from(section.querySelectorAll('.lt-faqs-toc__link'));
      if (!tocLinks.length || !window.IntersectionObserver) return;

      tocLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
          var target = document.getElementById(link.getAttribute('href').slice(1));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            tocLinks.forEach(function (link) {
              link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
            });
          }
        });
      }, { rootMargin: '-5% 0px -75% 0px' });

      themes.forEach(function (theme) { observer.observe(theme); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
